import React, { ReactNode } from 'react'
import DOMPurify from 'dompurify'
import { CustomReportCategory } from './typesCategory'
import { CustomReportVariable } from './typesVariable'
import { SectionType } from './typesSection'
import { masterConfig } from '../../../pages/reporting/custom/components/variable/form/masterConfig'
import { transformTitle } from './transUtils'

export const toHtml = (val: string) => {
  return val?.replaceAll('\n', '<br>')
}

export const toLine = (val: string) => {
  return val?.replaceAll('\n', ' ')
}

export const generateStyledElement = (transformedTitle: string) => {
  return React.createElement('div', {
    dangerouslySetInnerHTML: { __html: DOMPurify.sanitize(toHtml(transformedTitle)) }
  })
}

export const getCustomReportTableCategoryTitle = (
  c?: CustomReportCategory,
  categories?: CustomReportCategory[]
): string | ReactNode => {
  if (!c) return ''
  return generateStyledElement(transformTitle(c, categories))
}

export const isFieldDisabled = (record: CustomReportVariable, sectionType: SectionType, field: string): boolean => {
  const sectionConfig = masterConfig[sectionType]

  if (!sectionConfig) return true

  const groupConfig = sectionConfig[record.rowType]

  if (!groupConfig) return true
  const fields = Object.values(groupConfig).flat()

  return !fields.includes(field)
}
